import React from 'react';
import { useSelector } from 'react-redux';
import Chat from '../../containers/Chat/chat';
import PreChat from '../../containers/PreChat/preChat'
import { RootState } from '../../redux/store';


export const Frame: React.FC = () => {

    const currentPage = useSelector((state: RootState) => state.page.currentPage);

    return (
        <>
            {currentPage === 'chat' && <Chat />}
            {currentPage === 'pre-chat' && <PreChat />}
        </>
    );
};

export default Frame;
